import { isIntrisingEmail } from '../utils/permissions'

export default {
  computed: {
    isIntrising () {
      return isIntrisingEmail(this.user && this.user.email)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/permissionsMixin.js